'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _IBonus2 = require('api/IBonus');

var _IBonus3 = _interopRequireDefault(_IBonus2);

var _Factory = require('Models/Factory');

var _Factory2 = _interopRequireDefault(_Factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IBonusProxy = function (_IBonus) {
    (0, _inherits3.default)(IBonusProxy, _IBonus);

    function IBonusProxy(client, storage) {
        (0, _classCallCheck3.default)(this, IBonusProxy);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IBonusProxy.__proto__ || (0, _getPrototypeOf2.default)(IBonusProxy)).call(this, client, storage));

        _this.client = client;
        return _this;
    }

    (0, _createClass3.default)(IBonusProxy, [{
        key: '_send',
        value: function _send(command) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/command';

            return this.client.post(path, {
                data: {
                    command: command, params: params, channelId: this.channelId, profileId: this.profileId, onlineShopId: this.onlineShopId
                }
            });
        }
    }, {
        key: 'userAuthentication',
        value: function userAuthentication(username, password) {
            var captcha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var shopId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            return this._send('userAuthentication', [username, password, captcha, shopId], '/user');
        }
    }, {
        key: 'userRegistration',
        value: function userRegistration(password, shopId, params) {
            return this._send('userRegistration', [password, shopId, params], '/user');
        }
    }, {
        key: 'userConfirmRegistration',
        value: function userConfirmRegistration(_password, _shopId, _params) {
            var _ModelFactory$create$ = _Factory2.default.create('ConfirmRegistrationRequest', (0, _extends3.default)({
                shopId: _shopId,
                password: _password
            }, _params)).clearNullUndefinedProps(),
                shopId = _ModelFactory$create$.shopId,
                password = _ModelFactory$create$.password,
                params = (0, _objectWithoutProperties3.default)(_ModelFactory$create$, ['shopId', 'password']);

            return this._send('userConfirmRegistration', [password, shopId, params], '/user');
        }
    }, {
        key: 'userRegistrationOneClick',
        value: function userRegistrationOneClick(shopId, params) {
            return this._send('userRegistrationOneClick', [shopId, params], '/user');
        }
    }, {
        key: 'userConfirmRegistrationOneClick',
        value: function userConfirmRegistrationOneClick(shopId, params) {
            return this._send('userConfirmRegistrationOneClick', [shopId, params], '/user');
        }
    }, {
        key: 'passRecoverySend',
        value: function passRecoverySend(phone, id_shop) {
            return this._send('passRecoverySend', [phone, id_shop], '/command');
        }
    }, {
        key: 'sendVoiceCode',
        value: function sendVoiceCode(login, source, phone) {
            return this._send('sendVoiceCode', [login, source, phone], '/command');
        }
    }, {
        key: 'userRestorePassword',
        value: function userRestorePassword(login, newPassword, code) {
            return this._send('userRestorePassword', [login, newPassword, code], '/user');
        }
    }, {
        key: 'getUserData',
        value: function getUserData(access_token) {
            return this._send('getUserData', [access_token], '/user');
        }
    }, {
        key: 'getWishList',
        value: function getWishList(wish_list) {
            var access_token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this._send('getWishList', [wish_list, access_token], '/user');
        }
    }, {
        key: 'setWishList',
        value: function setWishList(wish_list) {
            return this._send('setWishList', [wish_list], '/user');
        }
    }, {
        key: 'userLogout',
        value: function userLogout() {
            return this._send('userLogout', [], '/user');
        }

        /**
         * @returns {Promise}
         */

    }, {
        key: 'getCatalog',
        value: function getCatalog() {
            return this._send('getCatalog');
        }
        /**
             * @returns {Promise}
             */

    }, {
        key: 'getPayment',
        value: function getPayment() {
            return this._send('getPayment');
        }
    }, {
        key: 'getPaymentsParamsFromPIPObyId',
        value: function getPaymentsParamsFromPIPObyId(shopPipoId) {
            return this._send('getPaymentsParamsFromPIPObyId', [shopPipoId]);
        }

        /**
         * @returns {Promise}
         */

    }, {
        key: 'getCategories',
        value: function getCategories() {
            return this._send('getCategories');
        }
    }, {
        key: 'getProductByCategory',
        value: function getProductByCategory(category_id) {
            var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var page_size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

            return this._send('getProductByCategory', [category_id, page_number, page_size]);
        }
    }, {
        key: 'getByCategory',
        value: function getByCategory(category_id) {
            var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var page_size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

            return this._send('getByCategory', [category_id, page_number, page_size]);
        }
    }, {
        key: 'getCategoryRecommended',
        value: function getCategoryRecommended(id) {
            return this._send('getCategoryRecommended', [id]);
        }
    }, {
        key: 'getProductById',
        value: function getProductById(id) {
            return this._send('getProductById', [id]);
        }
    }, {
        key: 'getProducts',
        value: function getProducts() {
            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var page_size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
            var categories = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
            var begin_time_create = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var end_time_create = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var begin_time_update = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            var end_time_update = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

            return this._send('getProducts', [name, page_number, page_size, categories, begin_time_create, end_time_create, begin_time_update, end_time_update]);
        }
    }, {
        key: 'orderCreate',
        value: function orderCreate(sum) {
            var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var user_agent = arguments[2];
            var utm_redirect_data = arguments[3];
            var currency_id = arguments[4];
            var delivery_address = arguments[5];
            var custom_fields = arguments[6];

            return this._send('orderCreate', [sum, products, user_agent, utm_redirect_data, currency_id, delivery_address, custom_fields], '/user');
        }
    }, {
        key: 'editOrder',
        value: function editOrder(order_id, sum) {
            var products = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var user_agent = arguments[3];
            var utm_redirect_data = arguments[4];
            var currency_id = arguments[5];

            return this._send('editOrder', [order_id, sum, products, user_agent, utm_redirect_data, currency_id], '/user');
        }
    }, {
        key: 'cancelOrder',
        value: function cancelOrder(order_id) {
            return this._send('cancelOrder', [order_id], '/user');
        }

        /**
         * Создание нового счёта для заказа
         */

    }, {
        key: 'paymentCreate',
        value: function paymentCreate(order_id) {
            return this._send('paymentCreate', [order_id], '/user');
        }
    }, {
        key: 'getOrders',
        value: function getOrders(page_number, page_size) {
            return this._send('getOrders', [page_number, page_size], '/user');
        }
    }, {
        key: 'getOrderById',
        value: function getOrderById(id) {
            return this._send('getOrderById', [id], '/user');
        }

        /**
         *Метод для редактирования заказа
         */

    }, {
        key: 'setOrder',
        value: function setOrder(order_id, client_comment, service_in_slug, delivery_address) {
            return this._send('setOrder', [order_id, client_comment, service_in_slug, delivery_address], '/user');
        }
    }, {
        key: 'setPayOrder',
        value: function setPayOrder(order_id, client_comment, service_in_slug, delivery_address, discount_sum, coupon_id, coupon_token, customer_coupon_id, custom_fields, child_orders, captcha) {
            return this._send('setPayOrder', [order_id, client_comment, service_in_slug, delivery_address, discount_sum, coupon_id, coupon_token, customer_coupon_id, custom_fields, child_orders, captcha], '/user');
        }

        /**
         * Пулучение выписки по счёту для пользователя
         */

    }, {
        key: 'getPipoOperations',
        value: function getPipoOperations(date_begin, date_end, id_account, page, page_size, channel_id) {
            return this._send('getPipoOperations', [date_begin, date_end, id_account, page, page_size, channel_id], '/user');
        }
    }, {
        key: 'paymentServices',
        value: function paymentServices(paymentInId) {
            return this._send('paymentServices', [paymentInId], '/user');
        }
    }, {
        key: 'payInnerPipo',
        value: function payInnerPipo(accountId, operationId) {
            var checkCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return this._send('payInnerPipo', [accountId, operationId, checkCode], '/user');
        }
    }, {
        key: 'checkCodeConfirmForPayInnerPipo',
        value: function checkCodeConfirmForPayInnerPipo(online_shop_id, orderId) {
            return this._send('checkCodeConfirmForPayInnerPipo', [online_shop_id, orderId], '/user');
        }
    }, {
        key: 'getDetailPayIn',
        value: function getDetailPayIn(operationId) {
            return this._send('getDetailPayIn', [operationId], '/user');
        }
    }, {
        key: 'getPageDetail',
        value: function getPageDetail(id, shopId) {
            return this._send('getPageDetail', [id, shopId], '/command');
        }
    }, {
        key: 'getProductForSlider',
        value: function getProductForSlider(type) {
            return this._send('getProductForSlider', [type]);
        }
    }, {
        key: 'getCategoryForSlider',
        value: function getCategoryForSlider() {
            return this._send('getCategoryForSlider', []);
        }
    }, {
        key: 'getLang',
        value: function getLang(lang) {
            return this._send('getLang', [lang], '/user');
        }
    }, {
        key: 'pipoProcessInput',
        value: function pipoProcessInput(operation_id, group_slug) {
            var additionalFieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var additionalFieldText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

            return this._send('pipoProcessInput', [operation_id, group_slug, additionalFieldName, additionalFieldText], '/user');
        }
    }, {
        key: 'changeName',
        value: function changeName(pipoId, name, newName) {
            return this._send('changeName', [pipoId, name, newName], '/user');
        }
    }, {
        key: 'changeMail',
        value: function changeMail(pipoId, newEmail, code) {
            return this._send('changeMail', [pipoId, newEmail, code], '/user');
        }
    }, {
        key: 'changeMailWithCode',
        value: function changeMailWithCode(pipoId, newEmail, code) {
            return this._send('changeMailWithCode', [pipoId, newEmail, code], '/user');
        }
    }, {
        key: 'changePhone',
        value: function changePhone(pipoId, newPhone, code) {
            return this._send('changePhone', [pipoId, newPhone, code], '/user');
        }
    }, {
        key: 'changePhoneWithCode',
        value: function changePhoneWithCode(pipoId, newPhone, code) {
            return this._send('changePhoneWithCode', [pipoId, newPhone, code], '/user');
        }
    }, {
        key: 'confirmMail',
        value: function confirmMail(pipoId, email, code) {
            return this._send('confirmMail', [pipoId, email, code], '/user');
        }
    }, {
        key: 'confirmMailWithCode',
        value: function confirmMailWithCode(pipoId, email, code) {
            return this._send('confirmMailWithCode', [pipoId, email, code], '/user');
        }
    }, {
        key: 'confirmEMailBySignature',
        value: function confirmEMailBySignature(order_id, confirm_signature) {
            return this._send('confirmEMailBySignature', [order_id, confirm_signature], '/user');
        }
    }, {
        key: 'confirmPhone',
        value: function confirmPhone(pipoId, phone, code) {
            return this._send('confirmPhone', [pipoId, phone, code], '/user');
        }
    }, {
        key: 'confirmPhoneWithCode',
        value: function confirmPhoneWithCode(pipoId, phone, code) {
            return this._send('confirmPhoneWithCode', [pipoId, phone, code], '/user');
        }
    }, {
        key: 'changePassword',
        value: function changePassword(login, newPassword, newRepassword, oldPassword) {
            return this._send('changePassword', [login, newPassword, newRepassword, oldPassword], '/user');
        }
    }, {
        key: 'shareBasket',
        value: function shareBasket(basket, customFields) {
            return this._send('shareBasket', [basket, customFields]);
        }
    }, {
        key: 'getSharedBasket',
        value: function getSharedBasket(code) {
            return this._send('getSharedBasket', [code]);
        }
    }, {
        key: 'postponeBasket',
        value: function postponeBasket(basket, customFields) {
            return this._send('postponeBasket', [basket, customFields], '/user');
        }
    }, {
        key: 'getPostpone',
        value: function getPostpone() {
            return this._send('getPostpone', [], '/user');
        }
    }, {
        key: 'deletePostpone',
        value: function deletePostpone(id) {
            return this._send('deletePostpone', [id], '/user');
        }
    }, {
        key: 'mergePostpone',
        value: function mergePostpone(mergeIds) {
            return this._send('mergePostpone', [mergeIds], '/user');
        }
    }, {
        key: 'getActualPrices',
        value: function getActualPrices(basket) {
            return this._send('getActualPrices', [basket]);
        }
    }, {
        key: 'getCouponsByToken',
        value: function getCouponsByToken(token) {
            var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this._send('getCouponsByToken', [token, user_id]);
        }
    }, {
        key: 'updateInn',
        value: function updateInn(inn) {
            return this._send('updateInn', [inn], '/user');
        }
    }, {
        key: 'updateUlName',
        value: function updateUlName(ul_name) {
            return this._send('updateUlName', [ul_name], '/user');
        }
    }, {
        key: 'addAddress',
        value: function addAddress(address) {
            return this._send('addAddress', [address], '/user');
        }
    }, {
        key: 'getChannelLastUpdateDate',
        value: function getChannelLastUpdateDate() {
            return this._send('getChannelLastUpdateDate');
        }
    }, {
        key: 'getChannelActualCatalogLabel',
        value: function getChannelActualCatalogLabel() {
            return this._send('getChannelActualCatalogLabel');
        }
    }, {
        key: 'getDomainInfo',
        value: function getDomainInfo(domain) {
            return this._send('getDomainInfo', [domain]);
        }
    }, {
        key: 'getAddresses',
        value: function getAddresses() {
            return this._send('getAddresses', [], '/user');
        }
    }, {
        key: 'updateAddress',
        value: function updateAddress(id, address, is_default) {
            return this._send('updateAddress', [id, address, is_default], '/user');
        }
    }, {
        key: 'deleteAddress',
        value: function deleteAddress(id) {
            return this._send('deleteAddress', [id], '/user');
        }
    }]);
    return IBonusProxy;
}(_IBonus3.default);

exports.default = IBonusProxy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/api/IBonusProxy.js
// module id = 742
// module chunks = 0